<h2 mat-dialog-title>{{ 'rooms.popups.reserve.reserve-error' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'rooms.popups.reserve.create-error-two' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; justify-content: end">
  <button mat-button (click)="onNoClick()">Ok</button>
</mat-dialog-actions>
